<template>
  <div :class="[roundClass]">
    <img
      :src="url"
      :class="[imgClass, full ? 'w-full h-full' : '']"
      :style="{ minHeight: height, minWidth: width }"
      @load="handleLoad"
      @error="handleError"
      alt=""
    />
  </div>
</template>

<script>
import imageURLDecrypt from "@/imageURLDecrypt.js";

export default {
  name: "ImageDecrypt",
  data() {
    return {
      url: require("@/assets/img/px3.png"),
      imageSrc: "",
    };
  },
  props: {
    src: {
      type: String,
      default: "",
    },
    round: {
      type: Boolean,
      default: false,
    },
    full: {
      type: Boolean,
      default: true,
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    imgClass: {
      type: String,
      default: "",
    },
  },
  computed: {
    roundClass() {
      return this.round ? "img-round" : "img-container";
    },
  },
  methods: {
    handleLoad() {
      this.$emit("load");
    },
    handleError() {
      this.$emit("error");
      this.url = require("@/assets/img/px3.png");
    },
    async loadImageURL() {
      if (!this.src) return this.url;

      if (this.src.indexOf("/assets/") !== -1) {
        return this.src;
      }

      if (this.src.startsWith("http")) {
        console.log("")
        const response = await imageURLDecrypt(this.src);
        if (response === "error") return this.url;
        return response;
      }

      let imgLink = this.src;
      if (imgLink.startsWith("/")) {
        imgLink = imgLink.substring(1);
      }

      const response = await imageURLDecrypt(
        `https://d3nh9ttgjr8i4l.cloudfront.net/${imgLink}`
      );
      if (response === "error") return this.url;
      return response;
    },
  },
  async mounted() {
    this.url = await this.loadImageURL();
  },
};
</script>

<style scoped lang="scss">
.img-container {
  width: 100%;
  height: 100%;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.img-round {
  width: 100%;
  height: 100%;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
  }
}
</style>
